// styles and images
import "../rate-sheets/RateSheets.css";

// components
import DisplayList from "../../components/DisplayList";

// internal hooks
import useGetFetch from "../../hooks/useGetFetch";

// store
import { dbDataStore, triggersStore } from "../../store/Store";
import Loading from "../../components/Loading";

export default function FuelSurcharge() {
  // global state
  const fuelSurchargeTrigger = triggersStore(
    (triggers) => triggers.fuelSurchargeTrigger
  );
  const setFuelSurchargeTrigger = triggersStore(
    (triggers) => triggers.setFuelSurchargeTrigger
  );
  const setFuelSurchargeData = dbDataStore(
    (dbData) => dbData.setFuelSurchargeData
  );
  const fuelSurchargeData = dbDataStore((dbData) => dbData.fuelSurchargeData);

  // other
  const { isPending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/fsc-rate-sheets`,
    setFuelSurchargeData
  );
  
  return !isPending ? (
    <div className="container-fluid">
      {error && <p className="error">Trouble Retrieving Data</p>}
      {!isPending && (
        <DisplayList
          coll={"Fuel Surcharge"}
          docs={fuelSurchargeData}
          err={error}
          trigger={fuelSurchargeTrigger}
          setTrigger={setFuelSurchargeTrigger}
          url={`${process.env.REACT_APP_BACKEND}/pc/fsc-rate-sheets`}
          setState={setFuelSurchargeData}
          statusToggle={true}
          setDeleteState={setFuelSurchargeData}
        />
      )}
    </div>
  ) : (
    <Loading />
  );
}
